import * as Yup from 'yup';
import { validationsLocale } from './validationsLocale';

Yup.setLocale(validationsLocale);

export const validations = {
    taxa_esforco: Yup.object().shape({
        net_monthly_income: Yup.number()
            .required(),
        mortgage: Yup.string(),
        car_loan: Yup.number(),
        personal_loan: Yup.string(),
        credit_card_debt: Yup.number(),
        other_loans: Yup.string()
    }),
    salario_liquido: Yup.object().shape({
        localizacao: Yup.string()
            .required(),
    }),
    prestacao_credito_habitacao: Yup.object().shape({
        capital_divida: Yup.number()
            .required(),
        taxa_juro: Yup.number()
            .required(),
        prestacao_pagar: Yup.number()
            .required(),
    }),
    variacao_euribor: Yup.object().shape({
        capital_divida: Yup.number()
            .required(),
    }),
    subsidio_desemprego: Yup.object().shape({
        idade: Yup.number()
            .required(),
    }),
    trabalhadores_independentes: Yup.object().shape({
        trabalhador: Yup.string()
            .required(),
    }),
    pensao_liquida: Yup.object().shape({
        localizacao: Yup.string()
            .required(),
    }),
    mais_valias: Yup.object().shape({
        titulo: Yup.string()
            .required(),
    }),
    imi: Yup.object().shape({
        valor_patrimonial_tributario: Yup.string()
            .required(),
    }),
    fixacao_prestacao: Yup.object().shape({
        euribor: Yup.string()
            .required(),
    }),
    despesas: Yup.object().shape({
        renda_prestacao: Yup.string()
            .required(),
    }),
    prestacao_amortizacao: Yup.object().shape({
        capital_divida: Yup.string()
            .required(),
    }),
    mac: Yup.object().shape({
        customerAge: Yup.number()
            .required(),
        equityDownAmount: Yup.number()
            .required(),
        monthlyNetIncome: Yup.number()
            .required(),
        monthlyLoanExpenses: Yup.number()
            .required(),
        propertyPurpose: Yup.string()
            .required(),
        propertyLocation: Yup.string()
            .required(),
        rateType: Yup.string()
            .required(),
    }),
    valor_imovel: Yup.object().shape({
        address: Yup.string()
            .required(),
    }),
};
